import { render, staticRenderFns } from "./MultiRowsBlock.vue?vue&type=template&id=79af4d4a"
import script from "./MultiRowsBlock.vue?vue&type=script&lang=ts"
export * from "./MultiRowsBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports